module.exports = __webpack_public_path__ + "teqbahn-assets/media/18.9979aba2.png";